import { Link } from 'react-router-dom';

const LOGO_URL = '/assets/logo.jpg';

export function Footer() {
  return (
    <footer className="bg-[#111827] text-white py-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <img src={LOGO_URL} alt="HumaClub" className="h-8 w-auto rounded" />
              <span className="font-heading font-semibold text-lg">HumaClub</span>
            </Link>
          </div>
          <div>
            <h4 className="font-heading font-semibold text-sm mb-4 text-gray-200">Platform</h4>
            <div className="flex flex-col gap-3">
              <Link to="/explore" className="text-sm text-gray-400 hover:text-white transition-colors font-body" data-testid="footer-explore">
                Explore Projects
              </Link>
              <Link to="/volunteer" className="text-sm text-gray-400 hover:text-white transition-colors font-body" data-testid="footer-volunteer">
                Volunteer
              </Link>
              <Link to="/principles" className="text-sm text-gray-400 hover:text-white transition-colors font-body" data-testid="footer-principles">
                Glass Box Principles
              </Link>
              <span className="text-sm text-gray-400 font-body">About</span>
              <span className="text-sm text-gray-400 font-body">Contact</span>
            </div>
          </div>
          <div>
            <h4 className="font-heading font-semibold text-sm mb-4 text-gray-200">HumaTek Ecosystem</h4>
            <div className="flex flex-col gap-3">
              <a href="https://humatek.io" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-400 hover:text-white transition-colors font-body" data-testid="footer-humatek">
                HumaTek
              </a>
              <a href="https://humadash.com" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-400 hover:text-white transition-colors font-body" data-testid="footer-humadash">
                HumaDash
              </a>
              <a href="https://humadashportal.com" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-400 hover:text-white transition-colors font-body" data-testid="footer-portal">
                HumaDash Portal
              </a>
            </div>
          </div>
          <div>
            <h4 className="font-heading font-semibold text-sm mb-4 text-gray-200">Legal</h4>
            <div className="flex flex-col gap-3">
              <span className="text-sm text-gray-400 font-body">Privacy Policy</span>
              <span className="text-sm text-gray-400 font-body">Terms of Service</span>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-800 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-gray-500 font-body">
            &copy; {new Date().getFullYear()} HumaClub, a Public Benefit Corporation. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
